import {
  useExperimentTiles,
  useTiles
} from '~/components/SearchResults/ResultsSection/hooks';
import { LOW_RESULTS_THRESHOLD } from '~/constants';
import {
  useInventoryVehicles,
  useSimilarVehicles
} from '~/contexts/InventoryContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import useGetVehiclesLoaded from './useGetVehiclesLoaded';

function useLoadedInventoryVehicles() {
  const inventoryVehicles = useInventoryVehicles();
  const { vehicles: similarVehicles, searchRequestId: svSearchRequestId } =
    useSimilarVehicles();

  const isInTileExperiment = useCheckExperimentBucket(
    'srp-tile-unlock-monthly',
    'experiment'
  );

  const controlTiles = useTiles(!isInTileExperiment);
  const experimentTiles = useExperimentTiles(isInTileExperiment);
  const tiles = isInTileExperiment ? experimentTiles : controlTiles;
  const shouldHaveSimilarVehicles = tiles.length < LOW_RESULTS_THRESHOLD;

  const { loadedInventoryVehicles, loadedSimilarVehicles } =
    useGetVehiclesLoaded({
      latestInventoryVehicles: inventoryVehicles,
      latestSimilarVehicles: similarVehicles,
      shouldHaveSimilarVehicles
    });

  return {
    loadedInventoryVehicles,
    loadedSimilarVehicles,
    shouldHaveSimilarVehicles,
    svSearchRequestId
  };
}

export default useLoadedInventoryVehicles;
